export interface RouteSeo {
  path: string;
  title: string;
  description: string;
}

export const SITE_URL = "https://tradestoolbelt.com";
export const SITE_NAME = "Trades Toolbelt";

export const routeSeo: RouteSeo[] = [
  {
    path: "/",
    title: "Trades Toolbelt — MEP Field Tools & Reference",
    description:
      "Offline-ready calculators, tables and references for electricians, pipefitters, HVAC and structural trades. Works on any phone, no signal needed.",
  },
  {
    path: "/pipe",
    title: "Pipe Sizing Calculators & Charts | Trades Toolbelt",
    description:
      "Size pipe fast with Hazen-Williams flow, pressure drop, steam and gas calculators, plus pipe weight and dimension charts for steel, copper and PVC.",
  },
  {
    path: "/electrical",
    title: "Electrical Calculators — NEC Wire Sizing | Trades Toolbelt",
    description:
      "NEC-based conductor ampacity, voltage drop, conduit fill, motor and panel schedule calculators for electricians working in the field.",
  },
  {
    path: "/ductwork",
    title: "Ductwork & HVAC Sizing Calculators | Trades Toolbelt",
    description:
      "SMACNA and ASHRAE duct sizing, friction rate, velocity, psychrometrics and sheet metal gauge tools for HVAC installers and estimators.",
  },
  {
    path: "/structural",
    title: "Structural Calculators — Beams & Anchors | Trades Toolbelt",
    description:
      "Beam capacity, anchor design, seismic bracing (ASCE 7-22) and load calculators for trade contractors and field engineers.",
  },
  {
    path: "/sketch",
    title: "Isometric Pipe Sketch Pad & Cut List | Trades Toolbelt",
    description:
      "Draw isometric piping runs with auto-inserted elbows and tees, then export a printable PDF sketch and material cut list.",
  },
  {
    path: "/trades",
    title: "Trade Hub — Calculators, Catalogs & Labor Rates | Trades Toolbelt",
    description:
      "Swap between pipe, plumbing, electrical, HVAC and structural. Each trade has its own calculators, material catalog and crew labor rates — all offline.",
  },
  {
    path: "/jobs",
    title: "Jobs — Sketches, Estimates & Field Reports | Trades Toolbelt",
    description:
      "Keep every project together: isometric sketches, floor plans, takeoffs, estimates, daily field reports and saved calculations — all offline on your phone.",
  },
  {
    path: "/shop",
    title: "Material Prices & Labor Rates | Trades Toolbelt",
    description:
      "One offline catalog of pipe, fittings, insulation, plumbing, HVAC, conduit and wire prices plus crew labor rates that feed every estimate.",
  },
  {
    path: "/help",
    title: "Help & FAQ | Trades Toolbelt",
    description:
      "Guides and frequently asked questions covering favorites, offline use, installation, and the codes behind every Trades Toolbelt calculator.",
  },
  {
    path: "/install",
    title: "Install Trades Toolbelt on Your Phone",
    description:
      "Step-by-step instructions to install Trades Toolbelt on iOS and Android so every calculator and reference table works offline.",
  },
  {
    path: "/settings",
    title: "Settings & Trade Defaults | Trades Toolbelt",
    description:
      "Set default conductor material, voltage, pipe material, duct class and unit system so every calculator opens ready for your work.",
  },
  {
    path: "/support",
    title: "Support Trades Toolbelt — Value 4 Value",
    description:
      "Trades Toolbelt is free and ad-free. Support ongoing development and new field tools through a value-for-value contribution.",
  },
];

export const defaultSeo: RouteSeo = routeSeo[0];

export function seoForPath(pathname: string): RouteSeo {
  const clean = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  return routeSeo.find((r) => r.path === clean) ?? defaultSeo;
}
